module.exports = {
    notAllowed: {
        errorTitle: 'contractsView-depositThirteenMonthsCustomErrorNotAllowedTitle',
        errorBody: 'contractsView-openyoungDataStep2TabForWhom',
        contentBuilder: 'depositThirteenMonths_customErrorNotAllowed',
        backButtonLabel: 'contractsView-errorBackButtonLabelGlobal',
        backButtonLink: '/myprofile/global'
    }
}
